import { message } from 'antd';
import i18n from '@/i18n';

export const API_PREFIX = 'v5';
/**
 * 网络错误码
 */
export enum HttpCode {
  Ok = 200,
  Redirect = 302,             // 重定向
  BadRequest = 400,           // 请求参数错误
  Unauthorized = 401,         // 登录状态已过期，请重新登录
  Forbidden = 403,            // 服务器拒绝本次访问
  NotFound = 404,             // 请求资源未找到
  InternalServerError = 500,  // 内部服务器错误
  BadGateway = 502,           // 网关错误
  ServiceUnavailable = 503,   // 服务不可用
  GatewayTimeout = 504,       // 网关超时
}

/**
 * 业务错误码
 */
export enum BusiCode {
  Ok = 0,
  ErrUnknown = 100001,         // 未知错误
  TempUnavailable = 100002,    // 服务暂时不可用
  Unauthorized = 100003,       // 未授权
  ParamInvalid = 100004,       // 参数不合法
  MethodNotAllowed = 100005,   // 请求方法错误
  PermissionDenied = 100007,   // 无权限、鉴权失败
  NoMatchData = 100009,        // 无匹配信息
  ExceedRateLimit = 100011,    // 请求频率达到上限
  Error = 100012,              // 服务端错误
  BundleIDRepeat= 40420,             // BundleID已被注册
  CodeVerificationError = 100013,
  ErrorToken = 100015,
  NotAllowedToExit = 8001001,
  ExceedMaxCountAdmin = 8002001,
  AlreadyApplied = 8003001,
  ExceedCantCancel = 8004001,       // 量不足无法解绑/删除
  InvalidBuglyID = 8001000,
  NotAdmin = 8004003,
  AlreadyBinded = 8003002,
  OnlyOneAdmin = 600001,             // 只有一位管理员，不能退出产品
  LimitUserAddProduct = 8003005,     // 用户名参与产品超过n个无法再次添加
  LimitCreateProduct = 8003006,      // 达到上限，无法创建更多产品
  limitSymbolProduct = 205111, // 免费版符号表上传上限
  PermissionDeniedForPullCmd = 2001, // 元宝产品拉取命令无权限
}

export const HTTP_MSG: Record<number, string> = {
  [HttpCode.Unauthorized]: '登录信息已过期，请重新登录。',
  [HttpCode.Forbidden]: '当前没有访问的权限。',
};

export const BUSI_MSG: Record<number, string> = {
  [BusiCode.ErrUnknown]: '发生未知错误。',
  [BusiCode.TempUnavailable]: '服务暂时不可用。',
  [BusiCode.Unauthorized]: '未授权。',
  [BusiCode.ParamInvalid]: '参数不合法。',
  [BusiCode.MethodNotAllowed]: '请求方法错误。',
  [BusiCode.PermissionDenied]: '当前没有访问的权限。',
  [BusiCode.NoMatchData]: '无匹配信息。',
  [BusiCode.ExceedRateLimit]: '当前请求频率达到上限。',
  [BusiCode.Error]: '服务端错误。',
  [BusiCode.LimitCreateProduct]: '当前账号创建的产品数量已达上限，如果需要创建更多产品，请联系Bugly小助手。',
};

export const COM_MSG = '当前服务不可用，请稍后再试。';

export const getHttpMsg = (code: number) => i18n.t(HTTP_MSG[code] ?? COM_MSG);

export const getBusiMsg = (code: number) => i18n.t(BUSI_MSG[code] ?? COM_MSG);

export const getCode = (e: Error) => parseInt(e.message, 10);

export const promptMsg = (msg: string, code: number, url?: string) => {
  const api = url?.substr(url?.lastIndexOf('/') + 1);
  message.error(`${msg} [${api}: ${code}]`);
};
